import React, { FC } from 'react'
import { Badge } from '@wmgtech/legato'

import { BadgeList } from 'components'
import { Tag } from 'shared/__gql-types'
import { NotificationsTagsProps } from './NotificationsTags.props'
import './Notifications.scss'

const NotificationTags: FC<NotificationsTagsProps> = ({ tags, isTagFollowed, onToggle }) => (
  <div className="notifications">
    <div>
      {tags.length ? (
        <BadgeList itemList={tags} onToggle={onToggle} title="Tags">
          {(tag: Tag) =>
            <Badge text={tag.label} containerStyle={isTagFollowed(tag.id) ? 'solid' : 'outline'} colorType="dark" />
          }
        </BadgeList>
      ) : null}
    </div>
    <div className="notifications-info">
      <h3 className="notifications__title">Storybox Tags</h3>
      We're excited to announce a new feature on Storybox: tags! Thanks to your feedback, we've added the ability to tag
      stories. You can be notified via Storybox or web push when a tag is used, and you can also manage your followed
      tags from the settings page. This new feature will help you connect with other users and find stories relevant to
      your interests. We hope you enjoy this new feature, and we look forward to hearing your feedback. Thank you for
      using Storybox!
    </div>
  </div>
)

export default NotificationTags
